export const hostPortSelector = (state): any => state.platform.hostPort;
